import styled from 'styled-components'

const Container = styled.div`
  padding: 12px;
  color: ${props => (props.isDark ? '#ffffff' : '#000000')};
  background-color: ${props => (props.isDark ? '#000000' : '#ffffff')};
`
export default Container
